module.exports = __webpack_public_path__ + "static/media/media5.b143c269.png";